import { useApiUrl, useMutation } from '@gemini/lux-ds-pms';
import { DevicesApiRoutes } from '../routes/routes';
import { SubmitExamDTO } from '@interfaces/interfaces';
import { useQueryClient } from '@tanstack/react-query';
import { QueryKeyList } from './querykeys';

interface Props {
  organizationCoreId: string | null;
  locationCoreId: string | null;
  date?: Date | null;
}


const useSubmitExams = ({
  organizationCoreId,
  locationCoreId,
  date,
}: Props) => {
  const queryClient = useQueryClient();
  
  const baseUrl = useApiUrl(
    DevicesApiRoutes.SubmitExamData,
    'DEVICE_BFF_API_BASE_URL'
  )
    ?.replace('{organizationCoreId}', organizationCoreId ?? '')
    ?.replace('{locationCoreId}', locationCoreId ?? '');

  return useMutation<void, SubmitExamDTO>(baseUrl || undefined, {
    method: 'POST',
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          QueryKeyList.ExamDataQueryKey,
          organizationCoreId,
          locationCoreId,
          date,
        ],
      });
    },
  });
};

export default useSubmitExams;
